import React from 'react';
import { useSelector } from 'react-redux';

import { Heading, Paragraph, Spacer } from '@zillow/constellation';

import propertyUtils from 'app/shared/utils/propertyUtils';

const ArchivePropertyModal = () => {
    const { address, isArchived } = useSelector(state => state.properties.propertyOverview);
    const { formattedCompleteAddress } = propertyUtils.formatAddress(address);

    const bodyText = isArchived ? `${formattedCompleteAddress} will be restored to your Properties page.` :
        'If you no longer own or manage the property, archive it to remove it from your properties.';
    const linkText = isArchived ? 'for rent & off market' : 'archived';
    const headerText = isArchived ? 'Remove property from archive?' : 'When to archive a property';

    return (
        <>
            <Heading level={4} fontFamily="serif">{headerText}</Heading>
            <Spacer marginY="sm">
                <Paragraph>{bodyText}</Paragraph>
            </Spacer>
            {!isArchived && (
                <Spacer marginBottom="sm">
                    <Paragraph>
                        You&#39;re still able to access the property by viewing
                        {` ${linkText} `}
                        properties from your Properties page.
                    </Paragraph>
                </Spacer>
            )}
        </>

    );
};

export default ArchivePropertyModal;
